<h1 mat-dialog-title>{{ 'ADD_CONTACT_DIALOG.TITLE' | translate }}</h1>

<div mat-dialog-content>

  <form [formGroup]="contactForm">

    @if (contactForm.errors?.['atLeastOneRequired'] && formSubmitted) {
    <div class="form-validation-error">
      <span> {{ 'ADD_CONTACT_DIALOG.ERROR.AT_LEAST_ONE_CONTACT_METHOD' | translate }}</span>
    </div>
    }

    @if (contactForm.errors?.['serverError']) {
    <div class="form-validation-error">
      {{ contactForm.errors?.['serverError'] | translate }}
    </div>
    }

    <div class="form-group">
      <mat-form-field style="display:inline;" class="flex-item">
        <mat-label>{{"ADD_CONTACT_DIALOG.CONTACT_NAME" | translate}}</mat-label>
        <input matInput formControlName="name" maxlength="50" required>
        @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
        <mat-error>{{ 'ADD_CONTACT_DIALOG.ERROR.ENTER_CONTACT_NAME' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field style="display:inline" class="flex-item">
        <mat-label>{{"ADD_CONTACT_DIALOG.COMPANY" | translate}}</mat-label>
        <input matInput formControlName="company" maxlength="150">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field style="display:inline" class="flex-item full-width">
        <mat-label>{{"GENERAL.EMAIL" | translate}}</mat-label>
        <input matInput type="email" formControlName="email">

        @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched && contactForm.get('email')?.value) {
        <mat-error>{{ 'MODAL.INVALID_EMAIL' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group phone-input-container">
      <mat-form-field class="phone-prefix-field">
        <mat-label>{{"ADD_CONTACT_DIALOG.PREFIX" | translate}}</mat-label>
        <input type="text" matInput formControlName="phonePrefix" [matAutocomplete]="auto" (focus)="onAutocompleteOpened()">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPrefix.bind(this)">
          @for (prefix of filteredPrefixes; track prefix.dial_code) {
          <mat-option [value]="prefix">{{prefix.display}}</mat-option>
          }
        </mat-autocomplete>
        @if (contactForm.errors?.['phonePrefixRequired']) {
        <mat-error>{{ 'ADD_CONTACT_DIALOG.ERROR.PHONE_PREFIX_REQUIRED' | translate}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="phone-number-field">
        <mat-label>{{"ADD_CONTACT_DIALOG.PHONE_NUMBER" | translate}}</mat-label>
        <input matInput type="tel" formControlName="phoneNumber">

        @if (contactForm.errors?.['phoneInvalid']) {
        <mat-error>{{ 'MODAL.INVALID_PHONE' | translate}}</mat-error>
        }
      </mat-form-field>

    </div>

  </form>

</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{'MODAL.CANCEL' | translate}}</button>
  <button mat-button type="button" [disabled]="contactForm.invalid" (click)="onSubmit()">{{"ADD_CONTACT_DIALOG.BUTTON_ADD_CONTACT" | translate}}</button>
</div>
